import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import FieldTypeMapping from "views/logic/fieldtypes/FieldTypeMapping";
import { adjustFormat, toUTCFromTz } from "util/DateTime";
import useUserDateTime from "hooks/useUserDateTime";
import { singleton } from "logic/singleton";
const fieldTypesUrl = qualifyUrl("/views/fields");
const _deserializeFieldTypes = (response) => response.map((fieldTypeMapping) => FieldTypeMapping.fromJSON(fieldTypeMapping));
const createFieldTypeRequest = (streams, timerange) => {
  let request = {};
  if (streams && streams.length > 0) {
    request = { streams };
  }
  if (timerange) {
    request = { ...request, timerange };
  }
  return request;
};
const fetchAllFieldTypes = (streams, timerange) => fetch("POST", fieldTypesUrl, createFieldTypeRequest(streams, timerange)).then(_deserializeFieldTypes);
const normalizeTimeRange = (timerange, userTz) => {
  switch (timerange == null ? void 0 : timerange.type) {
    case "absolute":
      return {
        type: "absolute",
        from: adjustFormat(toUTCFromTz(timerange.from, userTz), "internal"),
        to: adjustFormat(toUTCFromTz(timerange.to, userTz), "internal")
      };
    default:
      return timerange;
  }
};
const normalizeStreams = (streams) => (streams == null ? void 0 : streams.length) > 0 ? streams : void 0;
const useFieldTypes = (streams, timerange, enabled = true) => {
  const { userTimezone } = useUserDateTime();
  const _timerange = useMemo(() => normalizeTimeRange(timerange, userTimezone), [timerange, userTimezone]);
  const _streams = useMemo(() => normalizeStreams(streams), [streams]);
  return useQuery({
    queryKey: ["fieldTypes", _streams, _timerange],
    queryFn: () => fetchAllFieldTypes(_streams, _timerange),
    staleTime: 3e4,
    refetchOnWindowFocus: false,
    gcTime: 0,
    enabled
  });
};
export default singleton("hooks.useFieldTypes", () => useFieldTypes);
